import getImgixUrl from "./getImgixUrl";

/**
 * @deprecated This function was renamed to `getImgixUrl` (with the i)
 */
var getImgxUrl = getImgixUrl;
export default getImgxUrl;